var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AAA934BD-34FF-4F5B-8927-58E2CFECAD58") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coaching-Sessions",
    transform: "translate(-399.000000, -912.000000)",
    fill: "#9C9C9C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.358974,920.68685 L407.672128,917.000004 L411.358974,913.313132 L411.358974,920.68685 Z M400.313154,921.230773 L404.020077,917.52385 L405.318974,918.811594 C405.469333,918.960671 405.711974,918.960183 405.861718,918.810414 L407.128205,917.543927 L410.815051,921.230773 L400.313154,921.230773 Z M399.769231,920.686876 L399.769231,913.309465 L403.473821,916.982286 L399.769231,920.686876 Z M410.815026,912.769235 L405.588564,917.995722 L400.316897,912.769235 L410.815026,912.769235 Z M410.974359,912.000004 L400.153846,912.000004 C399.51841,912.000004 399,912.51785 399,913.15385 L399,920.846158 C399,921.480004 399.516103,922.000004 400.153846,922.000004 L410.974359,922.000004 C411.608205,922.000004 412.128205,921.483901 412.128205,920.846158 L412.128205,913.15385 C412.128205,912.520004 411.612103,912.000004 410.974359,912.000004 L410.974359,912.000004 Z",
    id: "email"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d3098d03.svg";
export { ForwardRef as ReactComponent };